import Container from 'react-bootstrap/Container';

export const Loader = () => (
  <Container className="Authenticated-Authorizing">
    <p>Please wait while we handle authentication...</p>
  </Container>
);
